import { render, staticRenderFns } from "./LabSelectionStep.vue?vue&type=template&id=3f11885e&scoped=true"
import script from "./LabSelectionStep.vue?vue&type=script&lang=js"
export * from "./LabSelectionStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11885e",
  null
  
)

export default component.exports